export default __webpack_public_path__ + "static/media/bnb.283d8cdb.svg";